import { useState, useEffect } from 'react'
import { debounce } from './useDebounce'

export const useWindowDimensions = ({
  width = 0,
  height = 0,
}: {
  width?: number
  height?: number
}) => {
  const [dimensions, setDimensions] = useState({
    width,
    height,
  })

  useEffect(() => {
    if (window) {
      const handleResize = () => {
        setDimensions({ width: window.innerWidth, height: window.innerHeight })
      }
      if (window) {
        window.addEventListener('resize', debounce(handleResize, 300))
      }
    }
    return () => {
      if (window) {
        const handleResize = () => {
          setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
          })
        }
        window?.removeEventListener('resize', handleResize)
      }
    }
  }, [])

  return {
    dimensions,
    setDimensions,
  }
}
